var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconAccordionUp = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.07264 14.5047L11.7372 9.11569C11.8707 8.96144 12.1278 8.96144 12.2628 9.11569L16.9274 14.5047C17.1006 14.7056 16.9444 15 16.6646 15H7.33542C7.0556 15 6.89935 14.7056 7.07264 14.5047Z",
    fill: "#FFF97D"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconAccordionUp);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon-accordion-up.61df25273d13582e994595c7d9d4001d.svg";